var _defs, _style;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "76.002029mm",
    height: "29.551531mm",
    viewBox: "0 0 76.002029 29.551531",
    id: "svg2623",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2617"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(85.126014,-198.56947)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2659",
    transform: "translate(0.50000098,-0.49999821)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2629",
    d: "m -19.747473,199.56998 c -5.794375,0 -9.577917,3.96875 -9.577917,10.53042 0,8.14916 5.794375,10.4775 9.948334,10.4775 3.122083,0 6.085416,-1.27 8.228541,-3.51896 l -2.672292,-2.67229 c -1.42875,1.27 -3.069166,2.03729 -5.503333,2.03729 -3.227916,0 -5.3975,-1.87854 -5.3975,-4.47146 h 14.393333 c -0.02646,-0.0265 2.4870837,-12.3825 -9.419166,-12.3825 m -4.974167,8.83708 c 0,-3.4925 2.645834,-5.15937 5.476875,-5.15937 2.831042,0 5.3975,1.71979 5.3975,5.15937 z",
    className: "st0",
    style: {
      fill: "#00dc06",
      strokeWidth: 0.26458332
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2631",
    d: "m -72.743514,208.0631 c -1.852083,-0.23812 -7.170208,-0.0264 -7.170208,-2.46062 0,-1.42875 2.248958,-2.2225 4.28625,-2.2225 2.169583,-0.0265 4.286249,0.58208 6.085416,1.74625 l 2.778125,-2.75167 c -0.820208,-0.66146 -3.862917,-2.80458 -8.863541,-2.80458 -4.550834,0 -8.651875,2.38125 -8.651875,6.19125 0,5.84729 7.064375,5.84729 10.00125,6.13833 1.799166,0.18521 3.413124,0.29104 3.413124,2.03729 0,1.64042 -2.487083,2.54 -4.418541,2.54 -3.148542,0 -5.027083,-1.03187 -6.879167,-2.69875 l -2.963333,2.9898 c 2.566458,2.48708 6.0325,3.83645 9.604375,3.81 5.291666,0 9.128125,-2.32834 9.128125,-7.01146 0,-3.09563 -2.090209,-4.94771 -6.35,-5.50334",
    className: "st0",
    style: {
      fill: "#00dc06",
      strokeWidth: 0.26458332
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2633",
    d: "m -57.556431,199.56998 c -2.936875,-0.0265 -5.820833,0.97896 -8.122708,2.80458 l 2.778125,2.77813 c 1.561041,-1.16417 3.439583,-1.77271 5.371041,-1.74625 3.518959,0 4.577292,1.40229 4.577292,2.98979 v 1.98437 h -6.270625 c -2.328333,0 -6.879167,0.58209 -6.879167,5.68855 0,3.75708 2.143125,6.50875 7.276042,6.50875 2.566458,0 4.524375,-0.82021 5.87375,-2.43417 v 2.03729 h 4.550833 v -13.46729 c 0,-4.70958 -2.883958,-7.14375 -9.154583,-7.14375 m 4.630208,13.25562 c 0,3.88938 -2.778125,3.67771 -5.23875,3.67771 -2.460625,0 -4.101041,-0.66146 -4.101041,-2.40771 0,-1.61395 1.296458,-2.16958 3.995208,-2.16958 h 5.344583 z",
    className: "st0",
    style: {
      fill: "#00dc06",
      strokeWidth: 0.26458332
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2635",
    d: "m -34.352473,199.99331 v 2.24896 c -1.561042,-1.77271 -3.413125,-2.67229 -5.926667,-2.67229 -4.312708,0 -6.535208,2.40771 -7.276041,5.00062 -0.291042,0.9525 -0.370417,2.77813 -0.370417,5.47688 0,2.54 0.02646,4.86833 0.899584,6.64104 1.243541,2.48708 4.233333,3.88938 6.746874,3.88938 2.434167,0 4.497917,-0.9525 5.926667,-2.59292 v 1.27 c 0,1.48167 -0.502708,2.46062 -1.455208,3.22792 -0.9525,0.76729 -2.143125,1.24354 -3.81,1.24354 -1.508125,0 -2.936875,-0.82021 -3.757084,-1.40229 l -3.069166,3.06916 c 1.984375,1.61396 4.339166,2.69875 6.905625,2.72521 2.460625,0.0529 4.868333,-0.74083 6.799791,-2.30187 1.825625,-1.42875 2.989792,-4.15396 2.989792,-7.01146 v -18.81188 z m 0,10.05417 c 0,1.56104 -0.02646,2.72521 -0.15875,3.33375 -0.291042,1.29646 -1.772708,3.01625 -4.471458,3.01625 -0.687917,0 -4.1275,-0.39688 -4.524375,-3.38667 -0.105834,-0.97896 -0.15875,-1.98437 -0.132292,-2.96333 0,-2.32833 0.105833,-3.06917 0.211667,-3.65125 0.238125,-1.16417 1.772708,-2.91042 4.445,-2.91042 3.254375,0 4.312708,2.2225 4.471458,3.09563 0.132292,1.13771 0.185208,2.30187 0.15875,3.46604",
    className: "st0",
    style: {
      fill: "#00dc06",
      strokeWidth: 0.26458332
    }
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style2625",
    type: "text/css"
  }, "\n\t.st0{fill:#00DC06;}\n")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSage);
export default __webpack_public_path__ + "static/media/sage.2b731643.svg";
export { ForwardRef as ReactComponent };